

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight } from 'lucide-react';
import { productCategories } from '../mock/data';

const ProductsSection = () => {
  const navigate = useNavigate();

  // Helper function handles navigation smoothly
  const handleQuoteRequest = (categoryTitle) => {
    // Ye 'categoryTitle' QuotePage mein location.state.category ban kar jayega
    navigate('/quote', { state: { category: categoryTitle } });
  };

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center space-y-4 mb-16">
          <Badge className="bg-teal-100 text-teal-700 hover:bg-teal-100 px-4 py-1 border-0 mx-auto">
            <span className="font-bold tracking-wider">MANUFACTURING • TRADE • EXPORT</span>
          </Badge>

          <h2 className="text-4xl md:text-5xl font-black text-slate-900">
            Any Pharmaceutical APIs. <br />
            {/* <span className="bg-gradient-to-r from-blue-600 to-teal-500 bg-clip-text text-transparent">
              Any Quantity.
            </span> */}
            <span className="bg-gradient-to-r from-[rgba(55,149,155,1)] via-[rgba(70,190,195,1)] to-[rgba(92,224,229,1)] bg-clip-text text-transparent">
  Any Quantity.
</span>
          </h2>

          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            From small trial orders to bulk container loads, Vigyan Healthcare sources, manufactures, and delivers a wide range of pharmaceutical APIs with assured quality.
          </p>
        </div>

        {/* Product Grid */}
        <div className="grid md:grid-cols-2 gap-10">
          {productCategories.map((product) => (
            <Card 
              key={product.id} 
              className="overflow-hidden hover:shadow-[0_20px_50px_rgba(8,_112,_184,_0.1)] transition-all duration-500 group border-0 bg-white"
            >
             <div className="relative h-72 overflow-hidden">
  <img
    src={product.image}
    alt={product.title}
    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
  />
                {/* Overlay Gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/20 to-transparent opacity-80"></div>
                
                {/* Category Badge on Image */}
                <div className="absolute bottom-6 left-6 flex flex-wrap gap-2">
                  {product.tags.map((tag, idx) => (
                    <Badge 
                      key={idx} 
                      className="bg-white/10 backdrop-blur-md text-white border-white/20 hover:bg-white/20 px-3 py-1 text-[10px] uppercase font-bold tracking-widest"
                    >
                      {tag}
                    </Badge>
                  ))}
                </div>
              </div>

              <CardContent className="p-8 space-y-5">
                <div className="space-y-2">
                  <h3 className="text-2xl font-black text-slate-800 group-hover:text-blue-600 transition-colors">
                    {product.title}
                  </h3>
                  <p className="text-slate-500 leading-relaxed text-sm">
                    {product.description}
                  </p>
                </div>
                
              <Button 
  onClick={() => handleQuoteRequest(product.title)}
  className="bg-slate-900 hover:bg-gradient-to-r hover:from-[rgba(55,149,155,1)] hover:via-[rgba(70,190,195,1)] hover:to-[rgba(92,224,229,1)] 
  text-white rounded-full px-8 py-6 font-bold shadow-lg transition-all duration-300 w-full md:w-auto group/btn"
>
  Explore {product.title} List
  <ArrowRight className="ml-2 w-4 h-4 group-hover/btn:translate-x-2 transition-transform" />
</Button>
              </CardContent>
            </Card>
          ))}
        </div>
        {/* Invisible product-related SEO keywords */}
<div className="hidden-keywords">
  API manufacturer India, Pharmaceutical API supplier India, Active pharmaceutical ingredient manufacturer, Bulk drug manufacturer India, API exporter India, API supplier for pharmaceutical companies, Pharmaceutical raw material supplier, High purity API manufacturer, GMP API manufacturer India, API manufacturing company India, API supplier India, Pharmaceutical API distributor, Bulk drug supplier India, API trading company India, Pharmaceutical raw material exporter, API wholesale supplier, Pharmaceutical ingredient supplier, API export company India, Reliable API supplier India, API supplier for antibiotic manufacturing
</div>
      </div>
    </section>
  );
};

export default ProductsSection;